var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTikcircle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 28,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5131 31.487L21.6791 35.653C22.2417 36.2154 23.0046 36.5314 23.8001 36.5314C24.5956 36.5314 25.3586 36.2154 25.9211 35.653L38.7871 22.787C38.9693 22.5984 39.0701 22.3458 39.0678 22.0836C39.0655 21.8214 38.9604 21.5706 38.775 21.3852C38.5895 21.1998 38.3387 21.0946 38.0765 21.0923C37.8143 21.09 37.5617 21.1908 37.3731 21.373L24.5071 34.239C24.3196 34.4265 24.0653 34.5318 23.8001 34.5318C23.535 34.5318 23.2807 34.4265 23.0931 34.239L18.9271 30.073C18.7385 29.8908 18.4859 29.79 18.2237 29.7923C17.9615 29.7946 17.7107 29.8998 17.5253 30.0852C17.3399 30.2706 17.2347 30.5214 17.2325 30.7836C17.2302 31.0458 17.331 31.2984 17.5131 31.487Z",
    fill: "#30C6D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTikcircle);
export default __webpack_public_path__ + "static/media/tikcircle.2b9a0333de6ef7eb092981bd0931fc7a.svg";
export { ForwardRef as ReactComponent };